import React from 'react'
import styled from 'styled-components'

interface BackButtonProps {
  onClick?: () => void
  ariaLabel?: string
}

const StyledBackButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
`

export const BackButton: React.FC<BackButtonProps> = ({ onClick, ariaLabel = '뒤로가기' }) => {
  return (
    <StyledBackButton onClick={onClick} aria-label={ariaLabel}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.2985 3.81282C12.5914 3.51992 13.0663 3.51992 13.3592 3.81282C13.6521 4.10571 13.6521 4.58058 13.3592 4.87348L7.70232 10.5303C7.40943 10.8232 6.93455 10.8232 6.64166 10.5303C6.34876 10.2374 6.34876 9.76256 6.64166 9.46967L12.2985 3.81282Z"
          fill="#253044"
        />
        <path
          d="M13.3591 15.1266C13.652 15.4195 13.652 15.8944 13.3591 16.1873C13.0662 16.4802 12.5913 16.4802 12.2984 16.1873L6.64154 10.5304C6.34865 10.2376 6.34865 9.76268 6.64154 9.46978C6.93444 9.17689 7.40931 9.17689 7.70221 9.46978L13.3591 15.1266Z"
          fill="#253044"
        />
      </svg>
    </StyledBackButton>
  )
}

export default BackButton
